import PtLayout from '@pt/views/layout'

export default {
  path: '/demo',
  component: PtLayout,
  name: 'demo',
  meta: {
    title: 'demo',
    payment: 'free',
  },
  hidden: true,
  children: [
    {
      path: 'table',
      name: 'demo.table',
      component: () => import('@pt/views/demo/table/index.vue'),
      meta: {
        title: '',
        defaultPath: '/demo/table',
        payment: 'free',
      },
    },
    {
      path: 'button',
      name: 'demo.button',
      component: () => import('@pt/views/demo/button/index.vue'),
      meta: {
        title: '',
        defaultPath: '/demo/button',
        payment: 'free',
      },
    },
    {
      path: 'input',
      name: 'demo.input',
      component: () => import('@pt/views/demo/input/index.vue'),
      meta: {
        title: '',
        payment: 'free',
      },
    },
    {
      path: 'select',
      name: 'demo.select',
      component: () => import('@pt/views/demo/select/index.vue'),
      meta: {
        title: '',
        payment: 'free',
      },
    },
    {
      path: 'aiinput',
      name: 'demo.aiinput',
      component: () => import('@pt/views/demo/aiinput/index.vue'),
      meta: {
        title: '',
        payment: 'free',
      },
    },
    {
      path: 'timeline',
      name: 'demo.timeline',
      component: () => import('@pt/views/demo/timeline/index.vue'),
      meta: {
        title: '',
        payment: 'free',
      },
    },
    {
      path: 'canvas',
      name: 'demo.canvas',
      component: () => import('@pt/views/demo/canvas/index.vue'),
      meta: {
        title: '',
        payment: 'free',
      },
    },
  ],
}
